export const prodConfigs = {
    serverUrl: process.env.REACT_APP_SERVER_URL,
    fileServer: process.env.REACT_APP_FILE_SERVER_URL
}